var _rect, _g, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservedFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4160_40465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 20,
    height: 20,
    fill: "#FFC150"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4160_40465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52031 6.53586C9.65759 6.04211 9.74224 5.6122 9.9085 5.21689C9.9596 5.09537 10.2326 5.01923 10.4088 5.01C10.9511 4.98155 11.1143 5.30379 11.1944 6.50664H18.8051C18.8051 6.2713 18.7974 6.03211 18.8066 5.7937C18.8256 5.32225 19.1368 5.00154 19.5654 5.00001C19.9941 4.99847 20.3083 5.31841 20.3289 5.78832C20.3388 6.0175 20.3304 6.24823 20.3304 6.53433C20.9009 6.53433 21.4569 6.56817 22.0075 6.52817C23.5466 6.41512 24.1803 7.13421 24.1651 8.69237C24.1163 13.5107 24.1476 18.3297 24.1468 23.1488C24.1468 24.4332 23.5862 25 22.3141 25C17.42 25 12.526 25 7.63193 25C6.41014 25 5.83203 24.4193 5.83203 23.1927C5.83203 18.2328 5.83203 13.273 5.83203 8.31321C5.83203 7.1319 6.41929 6.53663 7.58388 6.53509C8.2558 6.53356 8.92695 6.53509 9.52031 6.53509V6.53586ZM22.5909 11.1427V8.0971H20.3319C20.3319 8.34475 20.3388 8.57239 20.3304 8.80004C20.3129 9.29226 19.9918 9.62219 19.5494 9.61142C19.1223 9.60066 18.8226 9.27764 18.8058 8.80081C18.7974 8.56393 18.8043 8.32706 18.8043 8.09864H11.1738C11.1738 8.36167 11.1837 8.60316 11.1715 8.84311C11.1478 9.29302 10.8405 9.6022 10.4256 9.61066C9.99697 9.61912 9.67284 9.29995 9.65072 8.83388C9.63928 8.59393 9.64843 8.35321 9.64843 8.10095H7.39017V11.1427H22.5902H22.5909ZM13.9705 18.9435C13.3558 18.3544 12.7792 17.796 12.1935 17.2469C12.0661 17.1269 11.9189 17.01 11.7595 16.9469C11.4483 16.8239 11.0739 16.9746 10.8931 17.2569C10.6925 17.5722 10.7452 17.9675 11.0525 18.2651C11.7946 18.9835 12.5443 19.6933 13.2909 20.407C13.7913 20.8854 14.1398 20.8908 14.6348 20.4216C15.8467 19.2719 17.0562 18.1213 18.2666 16.97C18.5068 16.7416 18.7601 16.5247 18.9812 16.2794C19.2649 15.9648 19.2466 15.5295 18.9683 15.2365C18.6876 14.9419 18.2689 14.9158 17.9371 15.1857C17.7693 15.3219 17.6183 15.4788 17.4612 15.628C16.3065 16.7247 15.1519 17.8214 13.9712 18.9427L13.9705 18.9435Z",
    fill: "#9F70FD"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#9F70FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedFilter);
export default __webpack_public_path__ + "static/media/reserved_filter.aa2235a17ab8a9d40c3b254e54ce2b84.svg";
export { ForwardRef as ReactComponent };